import { AuthLevel, generateApiPath } from '@guiker/api-definition'

const paths = {
  quebecLease: generateApiPath({ prefix: AuthLevel.AUTH, name: 'quebec-lease' }),
}

export { paths }
